var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"citation",attrs:{"to":'/references/'+_vm.ref}},[_vm._v("["+_vm._s(_vm.ref)+"] "+_vm._s(_vm.citation))])}
var staticRenderFns = []

export { render, staticRenderFns }